function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2710",
  "data-name": "Path 2710",
  d: "M89.7,330.049h1.513l.2-1.5c.678-4.973,1.329-9.311,1.9-13.136,2.635-17.534,3.725-24.791-1.643-33.227-5.522-8.68-13.187-14.142-20.6-19.423-7.824-5.574-15.917-11.341-21.454-20.967-5.316-9.24-5.046-19.447.709-26.642,6.874-8.6,19.751-11.013,34.454-6.463a109.514,109.514,0,0,1,18.655,7.748c12.282,6.241,13.178,4.862,28.114-18.288,1.546-2.394,3.248-5.033,5.139-7.938l.837-1.288-1.175-.986C105.578,162.15,67.88,154.184,35.5,166.631c-23.687,9.1-39.64,27.472-42.678,49.13-3.451,24.621,10.271,49.953,38.642,71.327,18.439,13.9,17.633,23.368,17.1,29.632-.26,3.07-.508,5.969,1.595,8.257C53.686,328.816,63.293,330.049,89.7,330.049ZM70.859,202.966c-9.746,0-17.967,3.435-23.234,10.023-6.663,8.332-7.046,20.033-1.005,30.535,5.916,10.283,14.32,16.272,22.448,22.063,7.472,5.323,14.527,10.351,19.688,18.459,4.671,7.344,3.709,13.743,1.14,30.852-.52,3.449-1.1,7.313-1.706,11.682-22.933-.047-32.923-1.166-35.477-3.947-1.024-1.116-.943-2.7-.693-5.621.6-7.023,1.5-17.638-18.466-32.693C6.233,263.736-7.01,239.56-3.741,216.242c2.86-20.392,17.995-37.728,40.489-46.375,30.767-11.831,66.623-4.441,96.2,19.749-1.562,2.4-2.99,4.619-4.3,6.656-7.124,11.037-11.048,17.12-13.993,19.132-2.281,1.558-4.129.745-9.639-2.056a112.49,112.49,0,0,0-19.2-7.968A50.737,50.737,0,0,0,70.859,202.966Z",
  transform: "translate(7.697 -160.863)",
  fill: "#3d99b8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2711",
  "data-name": "Path 2711",
  d: "M41.462,322.832c13.533,0,28.1-8.559,28.1-27.353,0-18.742-14.568-27.278-28.1-27.278-14.046,0-28.266,9.37-28.266,27.278,0,8.42,3.078,15.515,8.9,20.517A29.623,29.623,0,0,0,41.462,322.832Zm0-51.164c11.864,0,24.637,7.451,24.637,23.812,0,16.411-12.772,23.886-24.635,23.886-11.946,0-24.8-7.476-24.8-23.886C16.661,279.119,29.516,271.667,41.46,271.667Z",
  transform: "translate(-13.194 -268.201)",
  fill: "#3d99b8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1173",
  "data-name": "Group 1173",
  transform: "translate(56.179 119.039)"
}, React.createElement("path", {
  id: "Path_2712",
  "data-name": "Path 2712",
  d: "M60.986,288.9h8.042l1.092-7.971c.645-4.725,1.267-8.871,1.816-12.547l.076-.5c2.756-18.345,4.141-27.554-2.732-38.352q-.77-1.209-1.577-2.342L64.881,229.2q.757,1.061,1.475,2.189c6.177,9.706,4.857,18.485,2.227,35.977l-.075.5c-.553,3.688-1.175,7.85-1.823,12.59l-.679,4.974h-5.02c-28.429,0-37.96-1.43-42.5-6.371a10.675,10.675,0,0,1-2.794-7.02l-3.46.189a14.139,14.139,0,0,0,3.7,9.176C21.4,287.359,30.662,288.9,60.986,288.9Z",
  transform: "translate(-12.233 -227.19)",
  fill: "#3d99b8"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1174",
  "data-name": "Group 1174",
  transform: "translate(65.046 53.655)"
}, React.createElement("path", {
  id: "Path_2713",
  "data-name": "Path 2713",
  d: "M29.481,209.47l3.447-.38a15.393,15.393,0,0,1-.1-1.732,13.6,13.6,0,0,1,1.806-6.907c3.037-5.25,9.739-8.009,17.971-7.446l.237-3.458c-9.634-.66-17.489,2.742-21.208,9.167a17.032,17.032,0,0,0-2.272,8.644A19.291,19.291,0,0,0,29.481,209.47Z",
  transform: "translate(-29.365 -189.467)",
  fill: "#3d99b8"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1175",
  "data-name": "Group 1175",
  transform: "translate(107.463)"
}, React.createElement("path", {
  id: "Path_2714",
  "data-name": "Path 2714",
  d: "M6.708,228.875c9.41,0,13.79-6.787,25.5-24.928l.1-.151c1.515-2.349,3.182-4.935,5.032-7.777l4.456-6.846-6.262-5.248c-14.873-12.46-31.045-21.012-48.067-25.413l-.867,3.357c16.518,4.271,32.232,12.585,46.706,24.715l3.91,3.272L34.43,194.13c-1.851,2.846-3.524,5.436-5.04,7.788l1.359,1.089-1.456-.939c-11.268,17.459-15.064,23.342-22.585,23.342-2.668,0-5.1-.906-7.931-2.269l-1.5,3.125C.534,227.831,3.383,228.875,6.708,228.875Z",
  transform: "translate(13.405 -158.511)",
  fill: "#3d99b8"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1176",
  "data-name": "Group 1176",
  transform: "translate(0 53.548)"
}, React.createElement("path", {
  id: "Path_2715",
  "data-name": "Path 2715",
  d: "M87.255,251.12l2.657-2.225C77.534,234.108,70.99,218.032,70.99,202.4a57.386,57.386,0,0,1,1.329-12.251l-3.385-.742A60.837,60.837,0,0,0,67.523,202.4C67.523,218.855,74.347,235.7,87.255,251.12Z",
  transform: "translate(-67.523 -189.405)",
  fill: "#3d99b8"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1178",
  "data-name": "Group 1178"
}, React.createElement("path", {
  id: "Path_2716",
  "data-name": "Path 2716",
  d: "M44.463,327.467h.165c17.685,0,35.587-11.968,35.587-34.84a37.51,37.51,0,0,0-1.844-11.871l-3.29,1.1a34,34,0,0,1,1.667,10.776c0,20.6-16.159,31.374-32.121,31.374Zm-31.88-18.506,3.09-1.569a32.292,32.292,0,0,1-3.331-14.766,30.818,30.818,0,0,1,5.635-18.5l-2.806-2.035a34.2,34.2,0,0,0-6.3,20.536A35.737,35.737,0,0,0,12.583,308.961Z",
  transform: "translate(-8.876 -272.091)",
  fill: "#3d99b8"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1181",
  "data-name": "Group 1181"
}, React.createElement("path", {
  id: "Path_2717",
  "data-name": "Path 2717",
  d: "M145.793,232.485h1.513l.2-1.5c.4-2.954.789-5.527,1.13-7.8,1.591-10.6,2.252-14.984-1.08-20.217-3.354-5.271-7.963-8.555-12.422-11.732-4.8-3.418-9.33-6.647-12.542-12.233-3.011-5.233-2.872-10.994.359-15.036,3.9-4.874,11.266-6.219,19.711-3.607a64.507,64.507,0,0,1,10.972,4.557c7.86,4,8.784,2.569,17.613-11.112.917-1.421,1.927-2.986,3.049-4.711l.837-1.288-1.175-.986c-18.48-15.485-41.146-20.26-60.618-12.774-14.313,5.5-23.956,16.622-25.8,29.745-2.087,14.891,6.162,30.173,23.229,43.032,10.641,8.025,10.2,13.2,9.88,16.981-.161,1.894-.328,3.855,1.13,5.442C124.067,231.727,129.675,232.485,145.793,232.485Zm-11.2-76.9c-6,0-11.083,2.132-14.348,6.219-4.142,5.181-4.4,12.434-.659,18.929,3.59,6.242,8.647,9.845,13.537,13.329,4.378,3.122,8.517,6.068,11.509,10.771,2.635,4.139,2.075,7.871.577,17.841-.284,1.891-.6,3.992-.931,6.344-9.166-.028-18.321-.345-19.945-2.115-.409-.445-.359-1.267-.229-2.8.345-4.063.924-10.864-11.247-20.042-16.015-12.067-23.787-26.195-21.881-39.782,1.662-11.857,10.488-21.947,23.607-26.99,17.87-6.871,38.687-2.669,55.96,11.223q-1.191,1.836-2.21,3.421c-4.184,6.481-6.489,10.053-8.12,11.169-.988.674-1.719.4-5.011-1.269a67.513,67.513,0,0,0-11.516-4.777A30.852,30.852,0,0,0,134.6,155.583Z",
  transform: "translate(-87.229 -130.572)",
  fill: "#ec4d11"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1183",
  "data-name": "Group 1183"
}, React.createElement("path", {
  id: "Path_2718",
  "data-name": "Path 2718",
  d: "M117.264,228.2c8.647,0,17.4-5.824,17.4-16.953,0-11.1-8.751-16.908-17.4-16.908-8.692,0-17.494,5.808-17.494,16.908C99.77,222.373,108.572,228.2,117.264,228.2Zm0-30.395c6.709,0,13.932,4.207,13.932,13.442,0,9.266-7.223,13.487-13.932,13.487-6.756,0-14.027-4.221-14.027-13.487C103.237,202.009,110.508,197.8,117.264,197.8Z",
  transform: "translate(-99.77 -194.336)",
  fill: "#ec4d11"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1185",
  "data-name": "Group 1185",
  transform: "translate(27.051 60.84)"
}, React.createElement("path", {
  id: "Path_2719",
  "data-name": "Path 2719",
  d: "M136.493,217.386h8.042l1.092-7.971c.392-2.863.768-5.368,1.1-7.581,1.683-11.187,2.687-17.87-2.148-25.467-4.137-6.5-9.583-10.384-14.391-13.809l-1.655-1.186-2.028,2.811,1.667,1.194c4.553,3.245,9.71,6.917,13.481,12.849,4.139,6.5,3.311,12.01,1.662,22.978-.35,2.342-.728,4.86-1.121,7.741l-.679,4.974h-5.02c-16.078,0-23.377-.633-26.968-4.541-2.652-2.888-2.364-6.266-2.175-8.5.307-3.616-.068-7.089-7.779-13.038l-2.116,2.746c6.843,5.278,6.638,7.675,6.443,9.994-.213,2.5-.607,7.134,3.077,11.143C111.386,216.53,118.545,217.386,136.493,217.386Z",
  transform: "translate(-97.454 -161.372)",
  fill: "#ec4d11"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1186",
  "data-name": "Group 1186",
  transform: "translate(44.736 41.872)"
}, React.createElement("path", {
  id: "Path_2720",
  "data-name": "Path 2720",
  d: "M113.821,159.439l3.342-.919a6.551,6.551,0,0,1-.244-1.718,4.393,4.393,0,0,1,.567-2.236,4.214,4.214,0,0,1,1.213-1.319l-2.018-2.818a7.694,7.694,0,0,0-2.2,2.4,7.842,7.842,0,0,0-1.031,3.973A9.969,9.969,0,0,0,113.821,159.439Z",
  transform: "translate(-113.452 -150.429)",
  fill: "#ec4d11"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1187",
  "data-name": "Group 1187",
  transform: "translate(48.076)"
}, React.createElement("path", {
  id: "Path_2721",
  "data-name": "Path 2721",
  d: "M112.987,177.548c7.628,0,10.972-5.179,18.293-16.528l7.493-11.537-6.262-5.248c-15.3-12.821-33.125-19.066-50.989-17.8l.244,3.458c16.979-1.193,33.91,4.765,48.518,17.005l3.909,3.272-5.822,8.975c-7.018,10.873-9.644,14.941-15.383,14.941-2.654,0-4.867-1.125-7.431-2.428a59.969,59.969,0,0,0-10.335-4.3,25.687,25.687,0,0,0-4.943-1.04l-.348,3.449a22.215,22.215,0,0,1,4.266.9,57.058,57.058,0,0,1,9.791,4.078C106.7,176.123,109.5,177.548,112.987,177.548Z",
  transform: "translate(-81.521 -126.271)",
  fill: "#ec4d11"
}));

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1188",
  "data-name": "Group 1188",
  transform: "translate(0 36.309)"
}, React.createElement("path", {
  id: "Path_2722",
  "data-name": "Path 2722",
  d: "M143.078,178.012l3.026-1.69a41.03,41.03,0,0,1-5.552-20.1A36.442,36.442,0,0,1,141.5,148l-3.378-.782a39.929,39.929,0,0,0-1.031,9A44.437,44.437,0,0,0,143.078,178.012Z",
  transform: "translate(-137.086 -147.219)",
  fill: "#ec4d11"
}));

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1190",
  "data-name": "Group 1190"
}, React.createElement("path", {
  id: "Path_2723",
  "data-name": "Path 2723",
  d: "M120.433,238.85c12.365,0,24.885-8.394,24.885-24.439,0-16.015-12.519-24.394-24.885-24.394-12.11,0-24.982,8.55-24.982,24.394A24.235,24.235,0,0,0,98.9,227.23l2.96-1.806a20.815,20.815,0,0,1-2.94-11.013c0-13.592,11.086-20.927,21.515-20.927,10.644,0,21.418,7.19,21.418,20.927,0,13.769-10.774,20.973-21.418,20.973Z",
  transform: "translate(-95.451 -190.017)",
  fill: "#ec4d11"
}));

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2724",
  "data-name": "Path 2724",
  d: "M120.6,209.773h1.513l.206-1.5c.693-5.078,1.359-9.507,1.945-13.414,2.687-17.887,3.8-25.292-1.673-33.892-5.635-8.855-13.457-14.428-21.021-19.816-7.99-5.694-16.255-11.582-21.912-21.416-5.436-9.446-5.156-19.884.725-27.24,7.03-8.788,20.2-11.261,35.215-6.609a111.961,111.961,0,0,1,19.05,7.911c12.507,6.359,13.421,4.947,28.656-18.66,1.576-2.442,3.312-5.136,5.241-8.1l.839-1.286L168.2,64.76C136.8,38.444,98.323,30.312,65.282,43.017c-24.167,9.29-40.446,28.029-43.543,50.124-3.524,25.122,10.481,50.97,39.432,72.783,18.837,14.2,18.016,23.879,17.47,30.28-.265,3.127-.517,6.079,1.619,8.4C83.851,208.518,93.652,209.773,120.6,209.773ZM101.364,80.112c-9.94,0-18.321,3.5-23.69,10.218-6.793,8.495-7.186,20.425-1.024,31.133,6.034,10.49,14.611,16.6,22.907,22.51,7.628,5.436,14.833,10.571,20.106,18.856,4.777,7.507,3.8,14.045,1.17,31.516-.53,3.531-1.123,7.486-1.745,11.96-23.446-.047-33.657-1.192-36.272-4.042-1.059-1.149-.974-2.766-.719-5.763.61-7.162,1.53-17.986-18.837-33.345-27.9-21.019-41.427-45.715-38.085-69.532,2.921-20.83,18.38-38.539,41.354-47.372,31.438-12.083,68.065-4.531,98.268,20.189-1.6,2.463-3.061,4.732-4.408,6.815C153.11,84.532,149.1,90.742,146.089,92.8c-2.338,1.6-4.238.768-9.874-2.1a114.857,114.857,0,0,0-19.6-8.131A51.767,51.767,0,0,0,101.364,80.112Z",
  transform: "translate(-21.205 -37.129)",
  fill: "#2d3e50"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2725",
  "data-name": "Path 2725",
  d: "M71.347,202.4c13.8,0,28.653-8.727,28.653-27.887,0-19.108-14.854-27.81-28.654-27.81-14.32,0-28.819,9.552-28.819,27.81C42.526,192.827,57.025,202.4,71.347,202.4Zm0-52.23c12.131,0,25.188,7.618,25.188,24.344,0,16.778-13.057,24.42-25.186,24.42-12.213,0-25.354-7.642-25.354-24.42C45.993,157.792,59.134,150.175,71.345,150.175Z",
  transform: "translate(-42.526 -146.708)",
  fill: "#2d3e50"
});

var _ref18 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1195",
  "data-name": "Group 1195",
  transform: "translate(57.629 122.795)"
}, React.createElement("path", {
  id: "Path_2726",
  "data-name": "Path 2726",
  d: "M91.159,167.561h8.51l1.153-8.431c.686-5.04,1.347-9.432,1.931-13.308,2.825-18.815,4.245-28.259-2.839-39.39-.17-.267-.343-.536-.518-.8l-2.895,1.91.487.751c6.389,10.039,5.033,19.054,2.335,37.016-.584,3.888-1.246,8.3-1.938,13.353l-.744,5.434H91.159c-29.161,0-38.959-1.489-43.689-6.637a10.876,10.876,0,0,1-2.739-5.5l-3.406.64a14.225,14.225,0,0,0,3.593,7.2C50.512,165.893,60.453,167.561,91.159,167.561Z",
  transform: "translate(-41.326 -105.631)",
  fill: "#2d3e50"
}));

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1196",
  "data-name": "Group 1196",
  transform: "translate(67.159 55.056)"
}, React.createElement("path", {
  id: "Path_2727",
  "data-name": "Path 2727",
  d: "M58.42,86.7l3.442-.406A16.38,16.38,0,0,1,61.75,84.4a13.549,13.549,0,0,1,1.8-6.885c3.175-5.484,10.327-8.238,19.206-7.332l.352-3.447c-10.289-1.057-18.685,2.345-22.559,9.042A16.98,16.98,0,0,0,58.283,84.4,19.513,19.513,0,0,0,58.42,86.7Z",
  transform: "translate(-58.283 -66.549)",
  fill: "#2d3e50"
}));

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1197",
  "data-name": "Group 1197",
  transform: "translate(111.829)"
}, React.createElement("path", {
  id: "Path_2728",
  "data-name": "Path 2728",
  d: "M33.844,106.821c9.793,0,14.291-6.975,26.32-25.614,1.572-2.435,3.305-5.122,5.228-8.081l4.714-7.242-6.621-5.55C48.78,48.015,32.808,39.418,16.012,34.785l-.92,3.342c16.312,4.5,31.845,12.866,46.166,24.865l4.269,3.576-3.038,4.669c-1.927,2.962-3.664,5.652-5.236,8.091-11.6,17.972-15.5,24.027-23.408,24.027a16.008,16.008,0,0,1-6.4-1.5l-1.354,3.189A19.239,19.239,0,0,0,33.844,106.821Z",
  transform: "translate(-15.092 -34.785)",
  fill: "#2d3e50"
}));

var _ref21 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1198",
  "data-name": "Group 1198",
  transform: "translate(0 54.406)"
}, React.createElement("path", {
  id: "Path_2729",
  "data-name": "Path 2729",
  d: "M118.591,130.111l2.645-2.243c-13.019-15.336-19.9-32.038-19.9-48.3a59.028,59.028,0,0,1,1.378-12.648l-3.385-.745A62.5,62.5,0,0,0,97.87,79.567C97.87,96.664,105.035,114.14,118.591,130.111Z",
  transform: "translate(-97.87 -66.174)",
  fill: "#2d3e50"
}));

var _ref22 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1200",
  "data-name": "Group 1200"
}, React.createElement("path", {
  id: "Path_2730",
  "data-name": "Path 2730",
  d: "M74.568,207.612h.17c18.224,0,36.673-12.332,36.673-35.906a38.629,38.629,0,0,0-1.9-12.233l-3.288,1.1a35.113,35.113,0,0,1,1.723,11.136c0,21.3-16.705,32.44-33.206,32.44ZM41.717,188.537l3.09-1.567a33.41,33.41,0,0,1-3.442-15.265,31.868,31.868,0,0,1,5.826-19.132l-2.806-2.031A35.238,35.238,0,0,0,37.9,171.705,36.846,36.846,0,0,0,41.717,188.537Z",
  transform: "translate(-37.899 -150.542)",
  fill: "#2d3e50"
}));

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2731",
  "data-name": "Path 2731",
  d: "M36.431,164.062h1.513l.206-1.5c.371-2.728.728-5.108,1.043-7.205,1.435-9.556,2.092-13.916-1.016-18.8-3.116-4.9-7.391-7.944-11.525-10.888-4.427-3.155-8.609-6.132-11.566-11.277-2.758-4.792-2.635-10.067.321-13.764,3.571-4.465,10.334-5.7,18.094-3.293a59.555,59.555,0,0,1,10.129,4.208c7.38,3.751,8.242,2.416,16.459-10.323.848-1.314,1.784-2.765,2.822-4.361l.837-1.286-1.177-.988C45.441,70.232,24.427,65.8,6.371,72.748c-13.286,5.108-22.238,15.433-23.947,27.62-1.938,13.825,5.709,28,21.538,39.928,9.786,7.38,9.384,12.128,9.088,15.594-.151,1.782-.309,3.623,1.08,5.132C16.268,163.351,21.478,164.062,36.431,164.062Zm-10.355-71.4c-5.593,0-10.327,1.99-13.376,5.8-3.867,4.836-4.1,11.6-.621,17.657,3.337,5.8,8.025,9.141,12.563,12.372,4.04,2.879,7.857,5.6,10.611,9.926,2.409,3.789,1.893,7.228.513,16.421-.258,1.718-.544,3.623-.844,5.751-8.412-.028-16.778-.321-18.241-1.914-.34-.373-.293-1.151-.179-2.494.322-3.787.861-10.122-10.455-18.657C-8.727,126.395-15.9,113.369-14.142,100.85c1.53-10.921,9.665-20.217,21.756-24.865,16.457-6.326,35.622-2.473,51.547,10.289-.712,1.1-1.369,2.118-1.985,3.07-3.86,5.98-5.985,9.275-7.474,10.292-.809.556-1.364.413-4.5-1.182a62.684,62.684,0,0,0-10.675-4.427A28.654,28.654,0,0,0,26.077,92.664Z",
  transform: "translate(17.871 -69.526)",
  fill: "#ec4d11"
});

var _ref24 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1204",
  "data-name": "Group 1204",
  transform: "translate(21.905 53.997)"
}, React.createElement("path", {
  id: "Path_2732",
  "data-name": "Path 2732",
  d: "M31.089,151.457h7.8l1.057-7.727c.364-2.659.712-4.983,1.019-7.035,1.567-10.417,2.5-16.655-2.05-23.813-3.87-6.082-8.945-9.7-13.424-12.889-1.65-1.177-3.21-2.286-4.617-3.453l-2.212,2.671c1.506,1.244,3.115,2.392,4.818,3.605,4.219,3.005,9,6.413,12.511,11.927,3.858,6.065,3.09,11.174,1.558,21.354-.322,2.149-.673,4.487-1.04,7.164l-.647,4.73H31.089c-14.918,0-21.7-.589-25.056-4.247-2.5-2.721-2.217-6.013-2.049-7.978.295-3.491-.076-6.609-7.613-12.292q-1.407-1.058-2.73-2.141l-2.194,2.685q1.378,1.126,2.837,2.224c6.6,4.981,6.43,7.044,6.245,9.23s-.577,6.774,2.952,10.616C7.668,150.646,14.355,151.457,31.089,151.457Z",
  transform: "translate(8.552 -96.54)",
  fill: "#ec4d11"
}));

var _ref25 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1205",
  "data-name": "Group 1205",
  transform: "translate(41.945 41.151)"
}, React.createElement("path", {
  id: "Path_2733",
  "data-name": "Path 2733",
  d: "M7.319,95.608l3.324-.986a5.664,5.664,0,0,1-.248-1.6,3.688,3.688,0,0,1,.468-1.865L8.038,89.129c-.066.1-.127.2-.185.305a7.066,7.066,0,0,0-.924,3.583A9.181,9.181,0,0,0,7.319,95.608Z",
  transform: "translate(-6.929 -89.129)",
  fill: "#ec4d11"
}));

var _ref26 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1206",
  "data-name": "Group 1206",
  transform: "translate(40.673)"
}, React.createElement("path", {
  id: "Path_2734",
  "data-name": "Path 2734",
  d: "M9.955,113.639c7.281,0,10.41-4.85,17.267-15.476l.2-.309c.79-1.224,1.654-2.564,2.609-4.026l4.319-6.642L28.279,82.1C15.231,71.166.267,65.387-14.992,65.387a58.886,58.886,0,0,0-8.372.6l.494,3.432a55.308,55.308,0,0,1,7.878-.562c14.436,0,28.628,5.5,41.044,15.9l3.718,3.113-2.645,4.065c-.955,1.466-1.823,2.811-2.617,4.04l-.2.309c-6.956,10.781-9.192,13.889-14.355,13.889-2.489,0-4.552-1.049-6.94-2.262a55.316,55.316,0,0,0-9.54-3.969,18.8,18.8,0,0,0-9.036-.79l.685,3.4a15.454,15.454,0,0,1,7.325.7,52.29,52.29,0,0,1,9,3.747C4,112.3,6.634,113.639,9.955,113.639Z",
  transform: "translate(23.364 -65.387)",
  fill: "#ec4d11"
}));

var _ref27 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1207",
  "data-name": "Group 1207",
  transform: "translate(0 33.875)"
}, React.createElement("path", {
  id: "Path_2735",
  "data-name": "Path 2735",
  d: "M33.544,111.8l3.1-1.555a37.423,37.423,0,0,1-4.2-16.858,34.023,34.023,0,0,1,.882-7.673l-3.375-.783a37.43,37.43,0,0,0-.974,8.457A40.822,40.822,0,0,0,33.544,111.8Z",
  transform: "translate(-28.977 -84.931)",
  fill: "#ec4d11"
}));

var _ref28 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1209",
  "data-name": "Group 1209"
}, React.createElement("path", {
  id: "Path_2736",
  "data-name": "Path 2736",
  d: "M13.118,176.807c11.641,0,23.427-7.905,23.427-23.016,0-15.083-11.786-22.974-23.427-22.974-11.4,0-23.52,8.051-23.52,22.974a22.112,22.112,0,0,0,8.779,18.146l2.085-2.768a18.434,18.434,0,0,1-7.4-15.378c0-12.672,10.332-19.508,20.054-19.508,9.918,0,19.96,6.7,19.96,19.508,0,12.835-10.043,19.55-19.96,19.55Z",
  transform: "translate(10.402 -130.816)",
  fill: "#ec4d11"
}));

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2737",
  "data-name": "Path 2737",
  d: "M10.068,166.556c8.061,0,16.223-5.432,16.223-15.813,0-10.353-8.162-15.771-16.223-15.771-8.108,0-16.314,5.418-16.314,15.771C-6.246,161.124,1.961,166.556,10.068,166.556Zm0-28.117c6.144,0,12.757,3.85,12.757,12.3,0,8.483-6.612,12.346-12.757,12.346-6.188,0-12.847-3.863-12.847-12.346a11.686,11.686,0,0,1,3.954-9.2A13.622,13.622,0,0,1,10.068,138.439Z",
  transform: "translate(6.246 -134.972)",
  fill: "#ec4d11"
});

var SvgFaq = function SvgFaq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 287.121,
    height: 466.691,
    viewBox: "0 0 287.121 466.691",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213",
    transform: "translate(-138.03)"
  }, React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(245.231 214.451)"
  }, React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(7.535 4.077)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref2), React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(60.186 190.122)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref3), React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(0)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref4, _ref5, _ref6, _ref7), React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(52.7 196.865)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref8)), React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192",
    transform: "translate(138.03 158.57)"
  }, React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    transform: "translate(7.525 7.455)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref9), React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(38.804 117.975)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref10), React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref11, _ref12, _ref13, _ref14), React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(31.317 110.489)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref15)), React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    transform: "translate(191.654 0)"
  }, React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(8.072 4.063)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref16), React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(61.819 193.993)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref17), React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(0)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref18, _ref19, _ref20, _ref21), React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201",
    transform: "translate(53.801 200.638)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref22)), React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212",
    transform: "translate(326.765 53.042)"
  }, React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(7.244 7.174)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref23), React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(0)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref24, _ref25, _ref26, _ref27), React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210",
    transform: "translate(28.972 113.406)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref28), React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211",
    transform: "translate(36.179 120.61)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref29))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFaq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FAQ.af6daeff.svg";
export { ForwardRef as ReactComponent };